var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer relative w-full h-px bg-gray-200"},[_c('div',{ref:"progressBar",staticClass:"timer__progress-bar absolute bottom-0 left-0 bg-black"})])}
var staticRenderFns = []

export { render, staticRenderFns }